import React, { Suspense, lazy } from 'react';
import { StickyAlert } from './components/sections/StickyAlert';
import { Hero } from './components/sections/Hero';
import { HeroPricing } from './components/sections/HeroPricing';
import { ProblemSection } from './components/sections/ProblemSection';
// Lazy load below-the-fold sections for better performance
const SalesLetter = lazy(() => import('./components/sections/SalesLetter').then(m => ({
  default: m.SalesLetter
})));
const Stats = lazy(() => import('./components/sections/Stats').then(m => ({
  default: m.Stats
})));
const Testimonials = lazy(() => import('./components/sections/Testimonials').then(m => ({
  default: m.Testimonials
})));
const Bonuses = lazy(() => import('./components/sections/Bonuses').then(m => ({
  default: m.Bonuses
})));
const Pricing = lazy(() => import('./components/sections/Pricing').then(m => ({
  default: m.Pricing
})));
const Upsell = lazy(() => import('./components/sections/Upsell').then(m => ({
  default: m.Upsell
})));
const Guarantee = lazy(() => import('./components/sections/Guarantee').then(m => ({
  default: m.Guarantee
})));
const FAQ = lazy(() => import('./components/sections/FAQ').then(m => ({
  default: m.FAQ
})));
const Footer = lazy(() => import('./components/sections/Footer').then(m => ({
  default: m.Footer
})));
const SectionFallback = () => <div className="min-h-[100px]" aria-hidden data-id="element-0" />;
export function App() {
  return <div className="min-h-screen font-sans text-gray-900 selection:bg-gold selection:text-forest-green" data-id="element-1">
      <StickyAlert data-id="element-2" />
      <main data-id="element-3">
        <Hero data-id="element-4" />
        <HeroPricing data-id="element-5" />
        <ProblemSection data-id="element-6" />
        <Suspense fallback={<SectionFallback data-id="element-8" />} data-id="element-7">
          <SalesLetter data-id="element-9" />
        </Suspense>
        <Suspense fallback={<SectionFallback data-id="element-11" />} data-id="element-10">
          <Stats data-id="element-12" />
        </Suspense>
        <Suspense fallback={<SectionFallback data-id="element-14" />} data-id="element-13">
          <Testimonials data-id="element-15" />
        </Suspense>
        <Suspense fallback={<SectionFallback data-id="element-17" />} data-id="element-16">
          <Bonuses data-id="element-18" />
        </Suspense>
        <Suspense fallback={<SectionFallback data-id="element-20" />} data-id="element-19">
          <Pricing data-id="element-21" />
        </Suspense>
        <Suspense fallback={<SectionFallback data-id="element-23" />} data-id="element-22">
          <Upsell data-id="element-24" />
        </Suspense>
        <Suspense fallback={<SectionFallback data-id="element-26" />} data-id="element-25">
          <Guarantee data-id="element-27" />
        </Suspense>
        <Suspense fallback={<SectionFallback data-id="element-29" />} data-id="element-28">
          <FAQ data-id="element-30" />
        </Suspense>
      </main>
      <Suspense fallback={<SectionFallback data-id="element-32" />} data-id="element-31">
        <Footer data-id="element-33" />
      </Suspense>
    </div>;
}